import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import { FiX } from 'react-icons/fi';
import { AnimatePresence, motion } from 'framer-motion';
import SearchIcon from './SearchIcon';
import './Search.css';
import { useNavigate } from 'react-router-dom';

const Search = ({ autoFocus = false, onSubmitted }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (!search.trim()) return;
    navigate(`/search/${encodeURIComponent(search.trim())}`);
    setSearch('');
    if (onSubmitted) onSubmitted();
  };

  const handleClear = () => {
    setSearch('');
    inputRef.current?.focus();
  };

  return (
    <Form
      className={`hd-search-container ${isFocused ? 'hd-search-focused' : ''} ${search ? 'hd-search-has-value' : ''}`}
      onSubmit={handleSearch}
    >
      <Form.Control
        ref={inputRef}
        type="search"
        placeholder="Rechercher..."
        className="hd-search-bar"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />

      <AnimatePresence>
        {search && (
          <motion.button
            type="button"
            key="clear"
            className="hd-search-clear"
            onClick={handleClear}
            aria-label="Effacer"
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.6 }}
            transition={{ duration: 0.15 }}
          >
            <FiX />
          </motion.button>
        )}
      </AnimatePresence>

      <button className="hd-search-button" type="submit" aria-label="Rechercher">
        <SearchIcon className="hd-search-icon" active={isFocused} />
      </button>
    </Form>
  );
};

export default Search;